import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Divider, Grid, Tab, Tabs } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";

import { OverView } from "../components/Overview";
import { BudgetTable } from "../components/BudgetTable";
import { Commitments } from "../components/Commitments";
import { Actuals } from "../components/Actuals";
import { Adjustments } from "../components/Adjustments";
import { Forecast } from "../components/Forecast";
import { Variations } from "../components/Variations";

export const Commercials: React.FC = () => {

    const { projectId } = useParams<{ projectId: string }>();

    const [currentTab, setCurrentTab] = useState("overview");
    const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
        setCurrentTab(tab);
    };

    const tabs = [
        { value: "overview", label: "Overview" },
        { value: "budgets", label: "Budgets" },
        { value: "adjustments", label: "Adjustments" },
        { value: "commitments", label: "Commitments" },
        { value: "actuals", label: "Actuals" },
        { value: "variations", label: "Variations" },
        { value: "forecast", label: "Forecast" },
    ];

    return (
        <Grid container height={'100%'}>
            <Box display="flex" flexDirection="column" height="100%" width={'100%'} gap={1.5}>
                <TabContext value={currentTab}>
                    <Box>
                        <Box display="flex" alignItems="center" alignContent="center">
                            <Tabs
                                value={currentTab}
                                onChange={handleChangeTab}
                                aria-label="Tabs"
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                sx={{ minHeight: "auto" }}
                            >
                                {tabs.map((t) => (
                                    <Tab
                                        key={t.value}
                                        sx={{ height: "auto", minHeight: "auto" }}
                                        label={t.label}
                                        value={t.value}
                                    />
                                ))}
                            </Tabs>
                        </Box>
                        <Divider />
                    </Box>
                    <Box flex={1} height={'100%'} overflow={'hidden'}>
                        <TabPanel value="overview" sx={{ p: 0, height: "100%", overflowX: "hidden", overflowY: "auto" }}>
                            <OverView projectId={projectId} />
                        </TabPanel>
                        <TabPanel value="budgets" sx={{ p: 0, height: "100%", overflowX: "hidden", overflowY: "auto" }}>
                            <BudgetTable projectId={projectId} />
                        </TabPanel>
                        <TabPanel value="adjustments" sx={{ p: 0, height: "100%", overflowX: "hidden", overflowY: "auto" }}>
                            <Adjustments projectId={projectId} />
                        </TabPanel>
                        <TabPanel value="commitments" sx={{ p: 0, height: "100%" }}>
                            <Commitments projectId={projectId} />
                        </TabPanel>
                        <TabPanel value="actuals" sx={{ p: 0, height: "100%" }}>
                            <Actuals projectId={projectId} />
                        </TabPanel>
                        <TabPanel value="variations" sx={{ p: 0, height: "100%", overflowX: "hidden", overflowY: "auto" }}>
                            <Variations projectId={projectId} />
                        </TabPanel>
                        <TabPanel value="forecast" sx={{ p: 0, height: "100%", overflowX: "hidden", overflowY: "auto" }}>
                            <Forecast projectId={projectId} />
                        </TabPanel>
                    </Box>
                </TabContext>
            </Box>
        </Grid>
    );
};